import { settingsViewMode } from '@/modules/neodash/enuns/settings.enun';

export const state = {
  viewMode: settingsViewMode.grid
};
